import type { CollectionListingCardProps } from '../../../components/cards/collectionListing/CollectionListingCard';
import { CollectionListingCard } from '../../../components/cards/collectionListing/CollectionListingCard';
import { ScrollSnapSlider } from '../../../components/utility/scrollSnapSlider/ScrollSnapSlider';
import styles from './CollectionListingSection.module.scss';

export type CollectionListingSectionProps = {
  title?: string;
  items: CollectionListingCardProps[];
};
export const CollectionListingSection = ({
  title,
  items = [],
}: CollectionListingSectionProps) => {
  return (
    <section className={styles.collectionListingSection}>
      <div className="container">
        {title && (
          <h2
            className={[
              'text-heading-h2-mobile text-heading-h2-desktop',
              styles.collectionListingSection__title,
            ].join(' ')}
          >
            {title}
          </h2>
        )}
      </div>
      {items.length && (
        <div className={styles.collectionListingSection__carousel}>
          <ScrollSnapSlider
            height={null}
            spacing={null}
            className={styles.collectionListingSection__carousel}
          >
            {items.map((collectionListingItem, index) => (
              <div
                key={`${collectionListingItem}-${index}`}
                className={styles.collectionListingSection__slide}
              >
                <CollectionListingCard {...collectionListingItem} />
              </div>
            ))}
          </ScrollSnapSlider>
        </div>
      )}
    </section>
  );
};
